import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

// Client-Groups settings list — groups with their assigned-client counts.
// Used ONLY on the Client Settings page (separate from the plain /lead-groups list).
export const leadGroupCountsApi = createApi({
  reducerPath: 'leadGroupCountsApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['LeadGroupCounts'],
  endpoints: (builder) => ({
    getLeadGroupCounts: builder.query<any, { search?: string } | void>({
      query: (arg) => {
        const search = arg && 'search' in arg ? arg.search : undefined;
        return {
          url: search ? `/lead-groups/counts?search=${encodeURIComponent(search)}` : '/lead-groups/counts',
          method: 'GET',
        };
      },
      providesTags: ['LeadGroupCounts'],
    }),
  }),
});

export const { useGetLeadGroupCountsQuery } = leadGroupCountsApi;
